import React from "react";
import type { ChatStore } from "./ChatStore";

export const ChatStoreContext = React.createContext<ChatStore | null>(null);

export function useChatStore(): ChatStore {
  const store = React.useContext(ChatStoreContext);
  if (!store) {
    throw new Error("useChatStore must be used within ChatStoreProvider");
  }
  return store;
}
